


















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';

import { ALoginParams } from '@/store/modules/user';

@Component
export default class extends Vue {
  @Action('login', { namespace: 'user' }) login: (a1: ALoginParams) => void;
  @Action('reset', { namespace: 'user' }) reset: (
    a1: ALoginParams,
  ) => Promise<void>;
  @State('error', { namespace: 'user' }) error: boolean;
  email = process.env.VUE_APP_PREFILL_LOGIN || '';
  password = process.env.VUE_APP_PREFILL_PASS || '';
  resetPass = false;
  resetPassword() {
    this.reset({ email: this.email, password: this.password }).then(
      (result) => {
        this.resetPass = false;
      },
    );
  }
}
